import { api } from '../axios'
import type { ApiResponse } from '../../../types'

export const serviceCategoriesApi = {
  getAll: () =>
    api.get<ApiResponse<any[]>>('/service-categories'),

  getActive: () =>
    api.get<ApiResponse<any[]>>('/service-categories/active'),

  getById: (id: number) =>
    api.get<ApiResponse<any>>(`/service-categories/${id}`),

  create: (data: { name: string, is_active?: boolean }) =>
    api.post<ApiResponse<any>>('/service-categories', data),

  update: (id: number, data: { name: string, is_active?: boolean }) =>
    api.put<ApiResponse<any>>(`/service-categories/${id}`, data),

  delete: (id: number) =>
    api.delete<ApiResponse>(`/service-categories/${id}`),

  hardDelete: (id: number) =>
    api.delete<ApiResponse>(`/service-categories/${id}/permanent`),
}

